import { SET_BASIC_PARAMS, UPDATE_INSTANCE } from './base-params-actions';
export function baseParamsReducer(state = { viewMode: 'site' }, action) {
    switch (action.type) {
        case SET_BASIC_PARAMS:
            return {
                ...state,
                ...action.payload,
            };
        case UPDATE_INSTANCE:
            if (state.instance === action.payload.instance) {
                return state;
            }
            return {
                ...state,
                instance: action.payload.instance,
                instanceValues: action.payload.instanceValues,
            };
        default:
            return state;
    }
}
//# sourceMappingURL=base-params-reducer.js.map